namespace('compass.group');

compass.requireLib('compass.util.parse');

compass.group.NamesHelper = (function() {
   
	return {
		getFarthestNoNameReservation : function(unassignedRoomsinfo){
			var farthestNoNameRezArriveDate = '';
			var farthestNoNameRezDepartDate = '';
			if(unassignedRoomsinfo.length){
				/*of all the no name reservations, find the one whose depart date is the farthest out*/
				/*this will determine the maximum checkout for no name reservations*/
				var farthestNoName = _.max(unassignedRoomsinfo, function(unassignedReservation){
					var departDate = compass.util.parse.ISODateParser(unassignedReservation.depart);
					return departDate.getTime();
				});
				var farthestNoNameRezArriveDate = compass.util.parse.ISODateParser(farthestNoName.arrive);
				var farthestNoNameRezDepartDate = compass.util.parse.ISODateParser(farthestNoName.depart);
			}
			return {'arrive' : farthestNoNameRezArriveDate, 'depart' : farthestNoNameRezDepartDate};
		},

		mergeGeneralAvailWithReservation : function(generalAvailNights, reservationArrive, reservationDepart){
			/*combine the farthest unassigned reservation info with the availability info for the farthest possible contiguous stay */
			var foundMaxDepartDate = false;
			_.each(generalAvailNights, function(currentGeneralAvailabilityNight){
				if(!foundMaxDepartDate){
					var curNightDate = compass.util.parse.ISODateParser(currentGeneralAvailabilityNight.date);
					/* there may be a case where there are no matching no name reservations, so default to false*/
					var dateIsPartOfFarthestNoNameRez = (curNightDate >= reservationArrive && curNightDate < reservationDepart) ? true : false;
					if(currentGeneralAvailabilityNight.availInfo == 'AVAIL' || dateIsPartOfFarthestNoNameRez){
						currentGeneralAvailabilityNight.availInfo = 'AVAIL';
					}
					else{
						foundMaxDepartDate = true;
					}
				}
				else{
					/*we found a hole i.e. there is no availability for this night from either general inventory*/
					/*mark everything after that as being unavailable*/
					currentGeneralAvailabilityNight.availInfo = 'OUT';
				}
			});
			/*mark the rest of the dates as being out*/
			return generalAvailNights;
		},

		getNightsBetween : function(arrive, depart, nights) {
			var currentNights = _.filter(nights, function(n) {
				if(n.nightBase){
					return n.nightBase.night >= arrive && n.nightBase.night < depart;
				}
				else{
					return n.date >= arrive && n.date < depart;
				}
			});
			return currentNights;
		}
	};
})();